export default "__VITE_PUBLIC_ASSET__8e9b15b3__"